import { render, staticRenderFns } from "./NewRealEstateActModal.vue?vue&type=template&id=0cf19507&scoped=true&"
import script from "./NewRealEstateActModal.vue?vue&type=script&lang=js&"
export * from "./NewRealEstateActModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf19507",
  null
  
)

export default component.exports